import { ReactElement } from "react";

export const HealthPage = (): ReactElement => <span>Healthy</span>;

export default HealthPage;